import React from 'react';
import { useFormikContext } from 'formik';
import { Button, ButtonProps } from 'react-bootstrap';

export const SubmitButton: React.FC<ButtonProps> = ({ children, ...rest }) => {
  const { isSubmitting } = useFormikContext();

  return (
    <Button type="submit" variant="primary" disabled={isSubmitting} {...rest}>
      {children}
    </Button>
  );
};
